import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import Component from '@glimmer/component';
import { t } from 'ember-intl';
import { Header, VStack } from 'tio-ui/components/layout';

export default class AccountActivityNewRouteComponent extends Component {
  @service declare router: RouterService;

  onLinkingSuccess = () => {
    this.router.transitionTo('authenticated.observability.upload');
  };

  didCancel = () => {
    this.router.transitionTo('authenticated.observability.upload');
  };

  <template>
    <VStack>
      <Header>{{t "account_linking.add_account"}}</Header>
    </VStack>
  </template>
}
